var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[(_vm.$store.state.isLogin)?_c('Report'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }